export { default } from './ExpansionPanelSummary';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/ExpansionPanelSummary/index.js
// module id = 796
// module chunks = 121